import script from "./ManageSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSurveys.vue?vue&type=script&setup=true&lang=js"

import "./ManageSurveys.vue?vue&type=style&index=0&id=f278d7fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f278d7fa"]])

export default __exports__